import React from 'react';

const About = () => {
  return (
    <div className="container">
      <h1 className="text-center mt-2">Acerca de Nosotros</h1>
      <div className="mt-2">
        <p>Esta es la página de información sobre RESVELTEX SAS.</p>
        <p>Aquí puedes agregar información sobre tu empresa.</p>
      </div>
    </div>
  );
};

export default About; 